import React from "react";
import NewCta from '../components/NewCta';
import Footer from '../components/Footer'
import SubFooter from "../components/SubFooter";
import '../Media-queries.css';


function Contact() {
  return (
    <>
      <NewCta />
      <Footer />
      <SubFooter />
    </>
  );
}

export default Contact;
